import Modal from '@components/Modal';
import { useModal } from '@components/Modal/ModalProvider';

import CTPreset, {CTPresetProps} from './CTPreset';

export function useCTPresetModal() {
  const { openModal, closeModal } = useModal();

  const open = (props:CTPresetProps) => {
    let id = '';
    id = openModal(
      <Modal
        key={props.componentKey}
        type='page'
        close={() => closeModal(id)}
        description={<CTPreset {...props} onClose={() => closeModal(id)} />}
      />
    );
  };

  return open;
}
